import React, { FC } from 'react';
import { MListTextIcon, MListTextIconSize, AIconSize } from '@marriott/mi-web-ui-kit';

import { PointsIconListProps } from './PointsWrapper.types';

export const PointsIconList: FC<PointsIconListProps> = ({ items }) => {
  if (!Array.isArray(items) || items.length === 0) return null;

  return (
    <ul className="pointswrapper__list" data-testid="points-wrapper-icon-list">
      {items.map((item, index) => {
        if (!item?.icon || !item?.text) return null;
        return (
          <li key={`${item.icon}-${index}`} className="pointswrapper__item">
            <MListTextIcon
              size={MListTextIconSize.M}
              aIcon={{ icon: item.icon, size: AIconSize.XL }}
              aTextInteractive={{ text: item.text }}
              className="pointswrapper__item-icon"
            />
          </li>
        );
      })}
    </ul>
  );
};
